export default __webpack_public_path__ + "assets/images/7da2f8b8e54b3eadef6726c27c43b025.svg";